import { makeVar } from "@apollo/client";
import { Env } from "core/utils";
import { trackWebVitals } from "core/tracking/tracking";
import { getCLS, getFID, getLCP } from "web-vitals";
var defaultNavConfig = {
    isShown: true,
    hideFooter: true,
};
export var navConfigVar = makeVar(getInitialNavConfig());
function getInitialNavConfig() {
    if (Env.isServer)
        return defaultNavConfig;
    if (Env.isClient) {
        getCLS(trackWebVitals);
        getFID(trackWebVitals);
        getLCP(trackWebVitals);
    }
    var appState = window.__APP_STATE__;
    if (typeof appState === "undefined")
        return defaultNavConfig;
    return appState.navConfig;
}
export var prepSetNavConfig = function (detailsController) { return function (navConfig) {
    navConfigVar(navConfig);
    detailsController.setNavConfig(navConfig);
}; };
